import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import authService from '../services/authService';

const ProtectedRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null); // null = loading
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    checkAuthentication();
  }, []);

  const checkAuthentication = async () => {
    try {
      // Önce localStorage'dan kontrol et
      if (!authService.isAuthenticated()) {
        setIsAuthenticated(false);
        setIsLoading(false);
        return;
      }

      // Token expired kontrolü
      if (authService.isTokenExpired()) {
        authService.logout();
        setIsAuthenticated(false);
        setIsLoading(false);
        return;
      }

      // API'ye token geçerliliği kontrolü (optional)
      // Bu adım ağır olabilir, isteğe bağlı
      try {
        await authService.validateToken();
        setIsAuthenticated(true);
      } catch (error) {
        console.warn('Token validation failed:', error);
        // Token validation başarısız olsa bile, localStorage'da varsa geçer
        setIsAuthenticated(authService.isAuthenticated());
      }
    } catch (error) {
      console.error('Authentication check failed:', error);
      setIsAuthenticated(false);
    } finally {
      setIsLoading(false);
    }
  };

  // Loading state
  if (isLoading) {
    return (
      <div className="min-h-screen bg-primary flex items-center justify-center">
        <div className="text-center">
          <div className="spinner mx-auto mb-4"></div>
          <p className="text-secondary">Yetkilendirme kontrol ediliyor...</p>
        </div>
      </div>
    );
  }

  // Not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Authenticated - show protected content
  return children;
};

export default ProtectedRoute;